import { defineComponent as _defineComponent } from 'vue'
import { NavItem } from '@sh/components/Layout/Sidebar/navItems';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { computed, getCurrentInstance } from 'vue';

interface Props {
  item: NavItem;
  collapsed: boolean;
  openedNavMenu: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarDropdown.ts',
  props: {
    item: null,
    collapsed: { type: Boolean },
    openedNavMenu: null
  },
  emits: ["update:collapsed"],
  setup(__props: any, { emit: emits }: { emit: ((e: 'update:collapsed', value: boolean) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: NavItem;
  collapsed: boolean;
  openedNavMenu: string;
};



const opened = computed(() => props.openedNavMenu === props.item.id);

const isSemiActive = computed(() => {
  if (!props.item.children) return;
  const instance = getCurrentInstance();
  const route = instance?.proxy.$route;
  return props.item.children.some((child) => route?.path.includes(child.url));
});

const path = computed(() => {
  const instance = getCurrentInstance();
  return instance?.proxy.$route.path;
});

function onClick() {
  emits('update:collapsed', opened.value);
}

return { __sfc: true,emits, props, opened, isSemiActive, path, onClick, OptimizerIconV2 }
}

})